import SponsorList from "./SponsorList";
import {createRoot} from "react-dom/client"

export default function () {
    const root = createRoot(document.getElementById("sponsorCarouselContainer"));
    root.render(<SponsorList sponsors={window.sponsors}/>);
}